import styled from 'styled-components';
import { LinkButton } from '../../Toolkit/Button/LinkButton';
import { StarIc } from '@dsch/dd-icons';

export const Rating = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const RatingLinkButton = styled(LinkButton)`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const StarIcon = styled(StarIc)`
  min-width: 16px;
  margin-right: ${({ theme }) => theme.spacing.S2};
`;

export const NoRatingLinkButton = styled(LinkButton)`
  font-weight: ${({ theme }) => theme.fontWeight.regular};
`;
